import { util } from './app.js';

const ThemeToggle = {
    Init: function () {

        const getStoredTheme = () => {
            try {
                const theme = localStorage.getItem("theme");
                return theme;
            } catch (e) {
                util.console.error("Error accessing localStorage:", e);
                return null;
            }
        };

        const setStoredTheme = theme => {
            try {
                localStorage.setItem("theme", theme);
                return true;
            } catch (e) {
                util.console.error("Error storing theme in localStorage:", e);
                return false;
            }
        };

        const getPreferredTheme = () => {
            const storedTheme = getStoredTheme();
            if (storedTheme) {
                return storedTheme;
            }

            return "light";
            //const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
            //return prefersDark ? "dark" : "light";
        };

        const setTheme = theme => {

            if (theme === "auto") {
                const systemTheme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
                document.documentElement.setAttribute("data-bs-theme", systemTheme);
            } else {
                document.documentElement.setAttribute("data-bs-theme", theme);
            }
        };

        // Set initial theme
        const initialTheme = getPreferredTheme();
        setTheme(initialTheme);

        const showActiveTheme = (theme, focus = false) => {

            const themeSwitcher = document.querySelector("#bd-theme");
            if (!themeSwitcher) {
                util.console.error("Theme switcher button (#bd-theme) not found!");
                return;
            }

            const themeSwitcherText = document.querySelector("#bd-theme-text");

            // Update the icon in the main button
            const themeSwitcherIcon = themeSwitcher.querySelector("i");
            if (themeSwitcherIcon) {
                // Remove all existing theme-related classes
                themeSwitcherIcon.classList.remove("bi-sun-fill", "bi-moon-fill", "bi-circle-half");

                // Add the appropriate icon class
                if (theme === "dark") {
                    themeSwitcherIcon.classList.add("bi-moon-fill");
                } else if (theme === "auto") {
                    themeSwitcherIcon.classList.add("bi-circle-half");
                } else {
                    themeSwitcherIcon.classList.add("bi-sun-fill");
                }
            } else {
                util.console.error("Theme switcher icon not found in main button!");
            }

            // Update dropdown items
            const themeButtons = document.querySelectorAll("[data-bs-theme-value]");

            themeButtons.forEach(element => {
                const buttonTheme = element.getAttribute("data-bs-theme-value");
                const isActive = buttonTheme === theme;

                // Update checkmark visibility
                const checkIcon = element.querySelector(".bi-check2");
                if (checkIcon) {
                    checkIcon.classList.toggle("d-none", !isActive);
                } else {
                    console.warn("Check icon not found in button for theme:", buttonTheme);
                }
            });

            // Update the button label
            if (themeSwitcherText) {
                const themeSwitcherLabel = `Toggle theme (${theme})`;
                themeSwitcher.setAttribute("aria-label", themeSwitcherLabel);
            }

            if (focus) {
                themeSwitcher.focus();
            }
        };

        // Handle system preference changes
        window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", () => {
            const storedTheme = getStoredTheme();
            if (storedTheme !== "light" && storedTheme !== "dark") {
                setTheme(getPreferredTheme());
            }
        });

        // Setup event listeners once DOM is loaded
        window.addEventListener("DOMContentLoaded", () => {

            // Show the correct active theme
            showActiveTheme(getPreferredTheme());

            // Add click handlers to theme buttons
            document.querySelectorAll("[data-bs-theme-value]").forEach(button => {
                button.addEventListener("click", () => {
                    const theme = button.getAttribute("data-bs-theme-value");
                    setTheme(theme);
                    showActiveTheme(theme, true);
                });
            });
        });

        // Immediate initialization in case DOMContentLoaded already fired
        if (document.readyState === "complete" || document.readyState === "interactive") {
            showActiveTheme(getPreferredTheme());

            document.querySelectorAll("[data-bs-theme-value]").forEach(button => {
                button.addEventListener("click", () => {
                    const theme = button.getAttribute("data-bs-theme-value");
                    setStoredTheme(theme);
                    setTheme(theme);
                    showActiveTheme(theme, true);
                });
            });
        }

        util.console.log("Theme toggle initialization completed");
    }
};

export default ThemeToggle;
